webpackJsonp([159311922826726],{

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _meta = __webpack_require__(16);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var metadata = {
	  title: "Qu'est-ce qu'un psychologue clinicien ? | Psychologue clinicienne les arceaux | Morgane Laroche",
	  description: "Quelles sont les champs et les modalités d'intervention du psychologue clinicien ? Description du cadre thérapeutique. Déontologie et principes fondamentaux."
	};
	
	var Psychologue = function Psychologue() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'container container--page' },
	    _react2.default.createElement(_meta2.default, { title: metadata.title, description: metadata.description }),
	    _react2.default.createElement(
	      'div',
	      { className: 'container__block' },
	      _react2.default.createElement(
	        'h1',
	        { className: 'container__block-title container__block-title--nomarge' },
	        'Qu\'est-ce qu\'un psychologue clinicien\xA0?'
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'container__block-subtitle' },
	        'A propos de la psychologie clinique \u2026'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'container__block-slogan' },
	        _react2.default.createElement(
	          'p',
	          { className: 'u-italic slogan__content' },
	          '\xAB Elle est une psychologie individuelle et sociale, normale et pathologique ; elle concerne le nouveau-n\xE9, l\u2019enfant, l\u2019adolescent, le jeune adulte, l\u2019homme m\xFBr, l\u2019\xEAtre vieillissant et enfin mourant. Le psychologue clinicien remplit trois grandes fonctions : de diagnostic, de formation, d\u2019expert [\u2026] \xBB'
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          'D. Anzieu'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-paragraphe' },
	        'Autrement dit, elle s\u2019adresse \xE0 ',
	        _react2.default.createElement(
	          'span',
	          { className: 'u-bold' },
	          'tous'
	        ),
	        '.'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-paragraphe' },
	        'A travers sa pratique, le psychologue clinicien tente de d\xE9celer certains \xE9tats de souffrance dans le but de proposer une th\xE9rapeutique permettant des am\xE9nagements positifs chez l\u2019individu.'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-paragraphe' },
	        'Comme en m\xE9decine, le travail clinique ob\xE9it \xE0 une m\xE9thode et \xE0 une analyse, les \xAB outils \xBB du clinicien allant de l\u2019entretien clinique, \xE0 la passation de tests (projectifs, psychom\xE9triques) et d\u2019\xE9chelles, ou encore l\u2019utilisation de m\xE9diations th\xE9rapeutiques telles que l\u2019hypnose, la relaxation, le Photolangage\xA9 \u2026'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-paragraphe u-mb' },
	        'Cette rencontre entre le psychologue et son patient est celle de deux individus singuliers, forts de leurs exp\xE9riences et parcours de vie mutuels. En cela, le psychologue va avant tout travailler \xE0 partir des \xE9motions (celles du patient mais les siennes \xE9galement) et accorder une grande place \xE0 la subjectivit\xE9\xA0: ce que le patient va exprimer \xE0 un moment donn\xE9 de son histoire, dans un contexte pr\xE9cis, ce dont il va \xEAtre particuli\xE8rement \xE0 l\u2019\xE9coute.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'container__block-subtitle' },
	        'Un exercice prot\xE9g\xE9'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-italic u-paragraphe' },
	        '\xAB Le respect de la personne dans sa dimension psychique est un droit inali\xE9nable. Sa reconnaissance fonde l\u2019action des psychologues \xBB'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-paragraphe' },
	        'L\u2019usage professionnel du titre de psychologue est d\xE9fini par l\u2019article 44 de la loi n\xB0855-772 du 25 Juillet 1985 compl\xE9t\xE9 par l\u2019article 57 de la loi n\xB02002-303 du 4 Mars 2002 qui rend obligatoire l\u2019inscription sur les listes ADELI.'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-paragraphe' },
	        _react2.default.createElement(
	          'span',
	          { className: 'u-bold' },
	          'Le titre \xE9tant prot\xE9g\xE9'
	        ),
	        ', est uniquement autoris\xE9 \xE0 exercer, tout individu titulaire d\u2019une Licence de Psychologie, d\u2019une ma\xEEtrise et d\u2019un Master 2 (anciennement nomm\xE9 D.E.S.S pour le Master \xAB professionnel \xBB ou D.E.A. pour la mention \xAB recherche \xBB).'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-paragraphe' },
	        'Par ailleurs, l\u2019exercice est soumis \xE0 un certain nombre de r\xE8gles que vous pouvez consulter via ce lien :',
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'container__block-link u-bold',
	            href: 'http://www.cncdp.fr/index.php/code-de-deontologie/code-de-deontologie-2012',
	            target: '_blank'
	          },
	          ' ',
	          'Code de d\xE9ontologie des psychologues'
	        ),
	        '.'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-paragraphe' },
	        'Quelques principes fondamentaux\xA0:'
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: 'container__content-list u-mb' },
	        _react2.default.createElement(
	          'li',
	          null,
	          'Respect des droits de la personne'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Comp\xE9tence'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Responsabilit\xE9 et autonomie'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Rigueur'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Int\xE9grit\xE9 et probit\xE9'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Respect du but assign\xE9'
	        )
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'container__block-subtitle' },
	        'Un psychologue, des psychologues'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-paragraphe' },
	        'Les enseignements de la psychologie et sa pratique sont nombreux et diff\xE8rent d\u2019un praticien \xE0 l\u2019autre. Chaque psychologue s\u2019appuie sur une ou plusieurs m\xE9thode(s), courant(s) de pens\xE9e, et inspiration(s) th\xE9orique(s) qui lui parlent, auxquels il a \xE9t\xE9 sensibilis\xE9 tout au long de sa formation et de son parcours.'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-paragraphe' },
	        'Cet accompagnement na\xEEt avant tout d\u2019une rencontre entre deux individus, dont chacun rev\xEAt des traits, des caract\xE9ristiques diff\xE9rents qui fondent leur singularit\xE9.'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'u-paragraphe' },
	        'Pour qu\u2019un travail d\u2019introspection et de r\xE9flexion puisse se tisser, il est essentiel que \xAB le courant passe \xBB et qu\u2019une alliance th\xE9rapeutique s\u2019installe.'
	      )
	    )
	  );
	};
	exports.default = Psychologue;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-psychologie-js-147ed00ea3ad873c80fc.js